export default {
    url: '/evaluation/:guid',
    abstract: true,
    template: '<ui-view></ui-view>'
};



// WEBPACK FOOTER //
// ./src/app/states/evaluation/evaluation/index.js